import { render, staticRenderFns } from "./DataTableAction.vue?vue&type=template&id=70a731be&scoped=true&"
import script from "./DataTableAction.vue?vue&type=script&lang=js&"
export * from "./DataTableAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a731be",
  null
  
)

export default component.exports